import React, { useState, useEffect } from "react";
import def_user_icon from '../../../images/def_user_icon.svg';
import { Link } from "react-router-dom";
import { getUserInfo } from "../../../../api/usercall";

const WHITE_FILTER = '[filter:brightness(0)_invert(1)]';

function Header() {
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        async function fetchUserData() {
            try {
                const response = await getUserInfo();
                setUserData(response.user);
            } catch (error) {
                console.error("Failed to fetch user data:", error);
            }
        }
        fetchUserData();
    }, []);

    return (
        <Link to="/profile#walletTopUp" className="no-underline block">
            <div className="flex items-center gap-3 p-4 bg-gradient-to-r from-[#147F26] to-[#1aaa34] rounded-xl mb-2">
                <div className="w-10 h-10 rounded-full bg-white/20 shrink-0 overflow-hidden">
                    <img
                        src={userData?.profilePicture || def_user_icon}
                        alt="user"
                        className={`w-full h-full ${userData?.profilePicture ? 'object-cover' : `object-contain p-1.5 ${WHITE_FILTER}`}`}
                    />
                </div>
                <div className="flex flex-col min-w-0">
                    <p className="m-0 text-[14px] font-semibold text-white truncate">
                        {userData ? userData.name : '...'}
                    </p>
                    <p className="m-0 text-[12px] text-white/70">
                        ID: {userData ? userData.id : '...'}
                    </p>
                </div>
            </div>
        </Link>
    );
}

export default Header;
